var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h2',{staticClass:"header-logo"},[_vm._v(_vm._s(_vm.systemName)+"--"+_vm._s(_vm.headerTitle))]),_vm._v(" "),_c('div',{staticClass:"header-search"},[_c('router-link',{attrs:{"to":{ name: 'search' }}},[_c('i',{staticClass:"el-icon-search"})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f72f8e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 